import { ManageGeneratorFormValue } from './manage-generator.interfaces';

export const GENERATOR_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
] as const;

export const GENERATOR_ORGANIZATION_OPTIONS = [
  { label: 'Government', value: 'Government' },
  { label: 'Private', value: 'Private' },
  { label: 'Public', value: 'Public' },
  { label: 'Joint Venture', value: 'Joint Venture' },
] as const;

export const GENERATOR_TYPE_OPTIONS = [
  { label: 'Hydro', value: 'Hydro' },
  { label: 'Solar', value: 'Solar' },
  { label: 'Thermal', value: 'Thermal' },
  { label: 'Bagasse', value: 'Bagasse' },
] as const;

export const GENERATOR_FUEL_TYPE_OPTIONS = [
  { label: 'ROR', value: 'ROR' },
  { label: 'PROR', value: 'PROR' },
] as const;

export const GENERATOR_OWNER_OPTIONS = [
  { label: 'NEA', value: 'NEA' },
  { label: 'NEA Subsidiary', value: 'NEA SUBSIDIARY' },
  { label: 'IPP', value: 'IPP' },
] as const;

export const LOG_SHEET_OPTIONS = [
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' },
] as const;

export function createManageGeneratorFormValue(): ManageGeneratorFormValue {
  return {
    generator_type: '',
    fuel_type: '',
    generator_name: '',
    promoter_company: '',
    project_unique_code: '',
    owner: 'NEA',
    delivery_point: '',
    corridor: '',
    ppa_date: '',
    substation_id: null,
    scada_station_code: '',
    entity_id: null,
    connecting_voltage_level_id: null,
    voltage_level_id: null,
    province_id: null,
    district_id: null,
    local_level_id: null,
    local_level: '',
    installed_capacity: '',
    capacity: '',
    no_of_units: '',
    other_parameter: [],
    log_sheet: 'YES',
    latitude: '',
    longitude: '',
    status: 'ACTIVE',
    contact_details: [],
  };
}
